export const domainToCountryCodeMap: { [key: string]: string } = {
    'master.sew-eurodrive.com': 'master',
    'www.sew-eurodrive.com': 'corporate',
    'www.sew-eurodrive.ae': 'ae',
    'www.sew-eurodrive.com.ar': 'ar',
    'www.sew-eurodrive.at': 'at',
    'www.sew-eurodrive.com.au': 'au',
    'www.sew-eurodrive.be': 'be',
    'brand.sew-eurodrive.com': 'bp',
    'www.sew-eurodrive.com.br': 'br',
    'www.sew-eurodrive.by': 'by',
    'www.sew-eurodrive.ca': 'ca',
    'www.imhof-sew.ch': 'ch',
    'www.sew-eurodrive.ci': 'ci',
    'www.sew-eurodrive.cl': 'cl',
    'www.sew-eurodrive.cm': 'cm',
    'www.sew-eurodrive.cn': 'cn',
    'www.sew-eurodrive.com.co': 'co',
    'www.sew-eurodrive.cz': 'cz',
    'www.sew-eurodrive.de': 'de',
    'www.sew-eurodrive.dk': 'dk',
    'www.sew-eurodrive.es': 'es',
    'www.sew-eurodrive.fi': 'fi',
    'www.usocome.com': 'fr',
    'www.sew-eurodrive.hu': 'hu',
    'www.sew-eurodrive.co.id': 'id',
    'www.seweurodriveindia.com': 'in',
    'www.sew-eurodrive.it': 'it',
    'www.sew-eurodrive.co.jp': 'jp',
    'www.sew-eurodrive.kr': 'kr',
    'kz.sew-eurodrive.com': 'kz',
    'www.sew-eurodrive.ma': 'ma',
    'www.sew-eurodrive.com.mx': 'mx',
    'www.sew-eurodrive.com.my': 'my',
    'www.sew-eurodrive.nl': 'nl',
    'www.sew-eurodrive.no': 'no',
    'www.sew-eurodrive.co.nz': 'nz',
    'www.sew-eurodrive-partner.com': 'ot',
    'www.sew-eurodrive.com.pe': 'pe',
    'www.sew-eurodrive.pl': 'pl',
    'www.sew-eurodrive.pt': 'pt',
    'www.sew-eurodrive.com.py': 'py',
    'www.sew-eurodrive.ro': 'ro',
    'www.sew-eurodrive.ru': 'ru',
    'www.sew-eurodrive.se': 'se',
    'www.sew-eurodrive.com.sg': 'sg',
    'www.sew-eurodrive.sk': 'sk',
    'www.sew-eurodrive.co.th': 'th',
    'www.sew-eurodrive.com.tr': 'tr',
    'www.sew-eurodrive.co.tz': 'tz',
    'www.sew-eurodrive.ua': 'ua',
    'www.sew-eurodrive.co.uk': 'uk',
    'www.seweurodrive.com': 'us',
    'www.sew-eurodrive.com.uy': 'uy',
    'www.sew-eurodrive.vn': 'vn',
    'www.sew-eurodrive.co.za': 'za',
};

export const countryToLangMap: { [key: string]: string } = {
    ae: 'en_us',
    ar: 'es_es',
    at: 'de_de',
    au: 'en_gb',
    be: 'en_us',
    bp: 'de_de',
    br: 'pt_br',
    by: 'ru_ru',
    ca: 'fr_fr',
    ch: 'de_de',
    ci: 'fr_fr',
    cl: 'es_es',
    cm: 'fr_fr',
    cn: 'zh_cn',
    co: 'es_es',
    cz: 'cs_cz',
    de: 'de_de',
    dk: 'da_dk',
    es: 'es_es',
    fi: 'fi_fi',
    fr: 'fr_fr',
    hu: 'hu_hu',
    id: 'en_us',
    in: 'en_gb',
    it: 'it_it',
    jp: 'ja_jp',
    kr: 'ko_kr',
    kz: 'ru_ru',
    ma: 'fr_fr',
    mx: 'es_es',
    my: 'en_us',
    nl: 'nl_nl',
    no: 'no_no',
    nz: 'en_gb',
    ot: 'en_us',
    pe: 'es_es',
    pl: 'pl_pl',
    pt: 'pt_pt',
    py: 'es_es',
    ro: 'en_us',
    ru: 'ru_ru',
    se: 'sv_se',
    sg: 'en_us',
    sk: 'sk_sk',
    th: 'en_us',
    tr: 'tr_tr',
    tz: 'en_us',
    ua: 'ru_ru',
    uk: 'en_gb',
    us: 'en_us',
    uy: 'es_es',
    ve: 'en_us',
    vn: 'en_us',
    za: 'en_us',
    corporate: 'de_de',
};

export const getAPIBaseUrlFromCaasBaseUrl = (caasBaseUrl: string): string => {
    switch (caasBaseUrl) {
        case 'https://caas.sew-d.com':
            return 'https://api.sew-d.com';
        case 'https://caas.sew-qa.com':
            return 'https://api.sew-qa.com';
        case 'https://caas.sew-eurodrive.com':
            return 'https://api.sew-eurodrive.com';
        default:
            return 'https://api.sew-eurodrive.com';
    }
};

export const getEnvironmentFromCaasBaseUrl = (caasBaseUrl: string): 'DEV' | 'QA' | 'PROD' => {
    switch (caasBaseUrl) {
        case 'https://caas.sew-d.com':
            return 'DEV';
        case 'https://caas.sew-qa.com':
            return 'QA';
        case 'https://caas.sew-eurodrive.com':
            return 'PROD';
        default:
            return 'PROD';
    }
};

// ClientID des CMS
export const getCmsClientId = (env: string): string => {
    switch (env) {
        case 'DEV':
            return '2a7db2fc-d449-4e2b-8c16-9304fd4f2ad3';
        case 'QA':
            return '2588562e-843c-4306-89af-a245962d5483';
        case 'PROD':
            return '7880acc6-f991-425b-b786-4de9b1039335';
        default:
            return '7880acc6-f991-425b-b786-4de9b1039335';
    }
};

// Scope des SAP-Systems (wird benötigt für Calls wie userData o.Ä. requests, die gegen SAP Backend gehen)
export const getSapScope = (env: string): string => {
    switch (env) {
        case 'DEV':
            return 'https://login.sew-d.com/c636b7c3-d751-4420-ba67-cba921820da0/FullAccess';
        case 'QA':
            return 'https://login.sew-qa.com/39230aeb-cb46-46aa-81e2-3b8de427bdcb/FullAccess';
        case 'PROD':
            return 'https://login.sew-eurodrive.com/057d8fbd-e788-4813-b701-a793281a46ff/FullAccess';
        default:
            return 'https://login.sew-eurodrive.com/057d8fbd-e788-4813-b701-a793281a46ff/FullAccess';
    }
};

export const CMS_SAP_API_NAME = 'CMS-SAP';
export const BASKET_S4_API_NAME = 'BASKET';

export const getCaasBaseUrl = (stage: string): string => {
    switch (stage) {
        case 'DEV':
            return 'https://caas.sew-d.com';
        case 'QA':
            return 'https://caas.sew-qa.com';
        case 'PROD':
            return 'https://caas.sew-eurodrive.com';
        default:
            return 'https://caas.sew-eurodrive.com';
    }
};
